/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Editor_Step_NInputs */

const en_editor_step_n = /** @type {(inputs: Editor_Step_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Step ${i?.n}`)
};

const de_editor_step_n = /** @type {(inputs: Editor_Step_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schritt ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Step {n}" |
*
* @param {Editor_Step_NInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_step_n = /** @type {((inputs: Editor_Step_NInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Step_NInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_step_n(inputs)
	return en_editor_step_n(inputs)
});